import { sampleClips } from "./sampleData.js";
export function getHolidaySample(staticAssetBaseUrls, themeId = "christmas-presents", themeVersion) {
    return {
        version: 1,
        occasionId: "holiday",
        themeId,
        themeVersion,
        staticAssetBaseUrls,
        videoFrame: {
            width: 1920,
            height: 1080,
            fps: 30,
        },
        introGreeting: {
            enabled: true,
            messages: [
                "Happy Holidays from the Smith Family!",
                "You're all in our hearts this season.",
            ],
        },
        outroGreeting: {
            enabled: true,
            messages: ["See you in the New Year!", "Love, the Smiths"],
        },
        faceCollageEnabled: true,
        userInput: {
            titleMessage: "Happy Holidays",
            subtitleMessage: "And a Happy New Year!",
        },
        music: {
            enabled: true,
            volumeDuringClips: "low",
            song: {
                id: "deck-the-halls",
                name: "Deck the Halls",
                urls: [
                    "https://memento-sandbox-music.s3.us-east-2.amazonaws.com/Deck_the_Halls.mp3",
                ],
                duration: 126.72,
            },
        },
        logo: {
            enabled: false,
            size: "medium",
            urls: [],
        },
        branding: {
            enabled: true,
        },
        clips: sampleClips,
    };
}
